import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import * as S from "../styles";

// Sucesso do cadastro de infoprodutor (spec checkout-jusfy-cupom-trial §4.2).
// Substitui o ModalPaymentSuccess neste modo: não houve pagamento, não há
// "valide seu e-mail" nem /primeiro-acesso — o aluno vai direto pro login do
// app do infoprodutor. Mesmos blocos visuais do EmailExistsModal; só a cor do
// ícone muda (verde de sucesso em vez do vermelho de erro).
const InfoprodutoresSuccessModal = ({ open, coupon, email, onAccess }) => {
  if (!open || !coupon) return null;

  return (
    <S.ModalOverlay open={open}>
      <S.EmailExistsDialog
        role="dialog"
        aria-modal="true"
        aria-labelledby="infoprodutores-success-title"
        aria-describedby="infoprodutores-success-desc"
      >
        <div className="icon" style={{ background: "#E4F6EF" }}>
          <CheckCircleOutlineIcon sx={{ color: "#01AB7D !important" }} />
        </div>
        <h3 id="infoprodutores-success-title">Conta criada!</h3>
        <p id="infoprodutores-success-desc">
          Seus {coupon.trial_days} dias grátis começaram. Entre com o e-mail{" "}
          <strong>{email}</strong> e a senha que você acabou de criar.
        </p>
        <div className="actions">
          <S.PrimaryButton type="button" onClick={onAccess}>
            Acessar {coupon.product_name}
          </S.PrimaryButton>
        </div>
      </S.EmailExistsDialog>
    </S.ModalOverlay>
  );
};

export default InfoprodutoresSuccessModal;
